import { ExperienceItem } from "@/components/ExperienceItem";
import { Section } from "@/components/Section";
import { experience } from "@/data/experience";
import { ui } from "@/i18n/ui";

export function Experience() {
  return (
    <Section id="experience" label={ui.experience} title={ui.experienceNote}>
      <div>
        {experience.map((role) => (
          <ExperienceItem key={`${role.company}-${role.periods[0].start}`} role={role} />
        ))}
      </div>
    </Section>
  );
}
